import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const SectionHeader = styled.div`
  border-bottom: 1px solid ${grey};
  color: #666;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 10px 20px;
  text-transform: uppercase;
`;

export default SectionHeader;
